export default {
  setLoading (state, payload) {
    state.loading = payload
  },
  setScreenerTemplates (state, payload) {
    state.screenerTemplates = payload
  },
  setScreenerTemplate (state, payload) {
    state.sreenerTemplate = payload
  },
  setPagination (state, payload) {
    state.pagination = payload
  },
  setScreenerTemplateParticipants (state, payload) {
    state.screenerTemplatesParticipants = payload
  }
}
